import React from 'react'
import ReactDOM from 'react-dom/client'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { QueryClient, QueryClientProvider } from 'react-query'
import { RecoilRoot } from 'recoil'

import App from '@/app/App'
import { FontGlobal } from '@/assets/fonts/font'
import { initSentry } from '@/shared/utils/sentry/init'
import { CommonStyle } from '@/styles/common/common'

initSentry()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const queryClient = new QueryClient()

root.render(
  <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY ?? ''}>
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <FontGlobal />
        <CommonStyle />
        <App />
      </RecoilRoot>
    </QueryClientProvider>
  </GoogleReCaptchaProvider>,
)
